import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WorkCenterIncompleteOperationsView } from "src/components/views/erp/production/jobQueue/WorkCenterIncompleteOperationsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/workCenterIncompleteOperations")({
	staticData: { title: i18n.t("in_progress_at_workcenter"), legacyViewKey: "workCenterIncompleteOperationsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WorkCenterIncompleteOperationsView />;
}
